// extracted by mini-css-extract-plugin
module.exports = {"styledSvg":"ChoroplethMap_styledSvg__2__gb"};